import { ContractImportWizardLoading } from '@/views/admin-contract-imports/wizard/wizard.loading';

export default ContractImportWizardLoading;
